import React, { useState } from "react";
import ImageIcon from "@mui/icons-material/Image";

type SafeImageProps = {
  src: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
};

export default function SafeImage({
  src,
  alt = "",
  width = 100,
  height = 100,
  style,
}: SafeImageProps) {
  const [hasError, setHasError] = useState(false);

  return hasError ? (
    <ImageIcon style={{ width, height, color: "#ccc" }} />
  ) : (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      style={style}
      onError={() => setHasError(true)}
    />
  );
}
